var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__pause--system icon--style--fill icon--size--large",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 1a11 11 0 1011 11A11 11 0 0012 1zm-1.273 15a1 1 0 01-2 0V8a1 1 0 012 0zm4.546 0a1 1 0 01-2 0V8a1 1 0 012 0z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }